import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const NONE = 'none'

export default {
  [PORTUGUESE]: {
    [NONE]: 'Nenhum',
  },

  [ENGLISH]: {
    [NONE]: 'None',
  },

  [SPANISH]: {
    [NONE]: 'Ninguno',
  },
}
